import { translateText } from "infra/translation/translate";
import EmployeeForm from "presentation/components/Employee/EmployeeForm";
import FunctionHeader from "presentation/components/Header/FunctionHeader";
import Spinner from "presentation/components/Shared/Spinner";
import usePermissionCheck from "presentation/hooks/use-check-permissions";
import { useParams } from "react-router-dom";

const EmployeeFormPage = () => {
  const { id } = useParams();
  const { isLoading } = usePermissionCheck({ requiredFunction: "employees" });

  if (isLoading) {
    return <Spinner />;
  }

  const isEditing = !!id;

  const title = isEditing
    ? translateText("Edit Employee", "pt")
    : translateText("Create Employee", "pt");

  return (
    <div>
      <FunctionHeader title={title} />
      <EmployeeForm />
    </div>
  );
};

export default EmployeeFormPage;
